var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { useEffect, useState } from 'react';
import Async from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';
import debouncePromise from 'debounce-promise';
import { getSortedOptions, getValuesMappedToOptions } from './lib';
export var AsyncSelect = function (props) {
    var defaultOptions = props.defaultOptions, value = props.value, defaultValue = props.defaultValue, valueKey = props.valueKey, isMulti = props.isMulti, isGrouped = props.isGrouped, onLoadOptions = props.onLoadOptions, isCreatable = props.isCreatable, isSorted = props.isSorted, labelKey = props.labelKey, handleSort = props.handleSort, getInitialOptionByValue = props.getInitialOptionByValue, isDebouncedLoadOptions = props.isDebouncedLoadOptions, clearAfterSelect = props.clearAfterSelect;
    var _a = __read(useState(), 2), reactSelectValue = _a[0], setReactSelectValue = _a[1];
    var _b = __read(useState(Array.isArray(defaultOptions) ? defaultOptions : [] // defaultOptions can be a boolean
    ), 2), asyncLoadedOptions = _b[0], setAsyncLoadedOptions = _b[1];
    useEffect(function () {
        var fetchInitialOptions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var option;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(defaultOptions === true)) return [3 /*break*/, 4];
                        if (!(props.value || props.defaultValue)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getInitialOptionByValue(props.value || props.defaultValue)];
                    case 1:
                        option = _a.sent();
                        if (option) {
                            isMulti
                                ? setAsyncLoadedOptions(option)
                                : setAsyncLoadedOptions([option]);
                            setReactSelectValue(option);
                        }
                        return [3 /*break*/, 4];
                    case 2: 
                    // keep the react-select logic of defaultOptions=true
                    return [4 /*yield*/, handleLoadOptions(props.inputValue || props.defaultInputValue || '')];
                    case 3:
                        // keep the react-select logic of defaultOptions=true
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchInitialOptions();
    }, []);
    // make the necessary conversion of value to option to pass it to react-select
    useEffect(function () {
        var _a = getValuesMappedToOptions({
            options: asyncLoadedOptions,
            value: value,
            defaultValue: defaultValue,
            valueKey: valueKey,
            isMulti: isMulti,
            isGrouped: isGrouped
        }), valueMappedToOption = _a.valueMappedToOption, defaultValueMappedToOption = _a.defaultValueMappedToOption;
        setReactSelectValue(valueMappedToOption || defaultValueMappedToOption);
    }, [asyncLoadedOptions, value, defaultValue]);
    var handleLoadOptions = function (inputValue, callback) { return __awaiter(void 0, void 0, void 0, function () {
        var options;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onLoadOptions(inputValue)];
                case 1:
                    options = _a.sent();
                    if (isSorted) {
                        options = getSortedOptions(isSorted, isGrouped, labelKey, options, handleSort);
                    }
                    callback && callback(options);
                    setAsyncLoadedOptions(options);
                    return [2 /*return*/, options];
            }
        });
    }); };
    var debouncedLoadOptions = debouncePromise(handleLoadOptions, 350);
    var handleChange = function (option) {
        props.onChange(option);
        clearAfterSelect && setAsyncLoadedOptions([]);
    };
    var commonProps = __assign(__assign({}, props), { 
        // omitting these
        isDebouncedLoadOptions: undefined, getInitialOptionByValue: undefined, clearAfterSelect: undefined, options: undefined, onChange: handleChange, value: reactSelectValue, loadOptions: isDebouncedLoadOptions
            ? debouncedLoadOptions
            : handleLoadOptions, defaultOptions: asyncLoadedOptions });
    if (isCreatable) {
        return React.createElement(AsyncCreatable, __assign({}, commonProps));
    }
    return React.createElement(Async, __assign({}, commonProps));
};
//# sourceMappingURL=AsyncSelect.js.map